
import TableList from "@components/templates/tablelist";
import {
    HttpGetReplenishMentList,
    HttpDeleteReplanishment,
    HttpAddressList
} from "@/service/replenishmentcycle";
import compUpdate from "./update";
import mixin from "./mixin";
import { mapState, mapGetters } from "vuex";
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            initData: '',
            addressCodeList: []
        };
    },
    created () {
        HttpAddressList().then(res => {
            this.addressCodeList = res.data.content.map(item => {
                return {
                    label: item.code,
                    value: item.code
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
    methods: {
        ajaxRequest: HttpGetReplenishMentList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "edit":
                    this.operate = {
                        show: true,
                        title: "编辑",
                        width: 900,
                        activeid: params,
                        component: "compUpdate",
                        showFooter: false
                    };
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        title: "删除",
                        width: 400,
                        alert: 'error',
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpDeleteReplanishment
                    };
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: '导入补货周期',
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/inboundPlanPeriod/batchImport",
                        name: "multipartFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/inboundPlanPeriod/template", {}, 'download');
                        },
                        on: {
                            "on-success": () => {
                                this.$emit('on-close');
                                this.$emit('on-update');
                            }
                        }
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/inboundPlanPeriod/export",
                        {
                            search: {
                                ...this.formData.search
                            }
                        }
                        , {
                            executor: 'request',
                            download: true,
                        }).catch(err => {
                            this.$VMessage.error(err.message);
                        })
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: this.handleAuth("fbb.inboundperiod.update"),
                    params: id,
                    operate: 'edit'
                },
                {
                    label: '删除',
                    show: this.handleAuth("fbb.inboundperiod.update"),
                    params: id,
                    operate: 'delete'
                },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getSystemPortList', 'getCompanyList', 'getFilterDisabledWarehouse']),
        ToolsData() {
            return [
                {
                    name: "导入",
                    operate: 'import',
                    theme: "primary",
                    show: this.handleAuth("fbb.inboundperiod.update")
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'export',
                    theme: 'default',
                    show: this.handleAuth("fbb.inboundperiod.query")
                }
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: "运输类型",
                    tag: 'Select',
                    key: 'IN_transportType',
                    options: this.getTransportType,
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: "发运港",
                    tag: 'Select',
                    key: 'IN_portCode',
                    options: this.getSystemPortList.map(item => {
                        return {
                            value: item.label,
                            label: item.label
                        }
                    }),
                    props: {
                        multiple: true,
                        filterable: true,
                        clearable: true
                    },
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: "目的仓",
                    tag: 'Select',
                    options: this.addressCodeList,
                    props: {
                        multiple: true,
                        filterable: true,
                        clearable: true
                    },
                    key: 'IN_orgWarehouseCode',
                    show: true,
                    style: 'width: 130px;'
                },
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id',
                    // fixed: 'left'
                }, {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                    // fixed: 'left'
                }, {
                    title: "运输类型",
                    key: "transportTypeName",
                    // render: (h, { row }) => {
                    //     let item = this.getTransportType.filter(item => {
                    //         return item.value == row.transportType
                    //     })[0];
                    //     return <div>{item.label}</div>;
                    // }
                },
                {
                    title: "货物筹备装柜期(天)",
                    key: "loadingDay"
                },
                {
                    title: "装柜到开船等待期(天)",
                    key: "loadingShipDay"
                },
                {
                    title: "目的港卸货周期(天)",
                    key: "unloadingPortDay"
                },
                {
                    title: "提柜周期(天)",
                    key: "pickUpDay"
                },
                {
                    title: "预约送仓(天)",
                    key: 'reserveWarehouseDay',
                },
                {
                    title: "卸柜周期",
                    key: "unloadingDay"
                },
                {
                    title: "还空柜周期(天)",
                    key: 'emptyPickUpDay',
                },
                {
                    title: "发运港",
                    key: "portCode"
                },
                {
                    title: "目的仓",
                    key: 'orgWarehouseCode',
                },
                {
                    title: "发运周期(天)",
                    key: 'shipDay',
                },
                {
                    title: "合计",
                    key: 'totalDay'
                },
            ];
        },

    },

};
